import { RecordingStatus } from "@/store/audio-capture/models/recording-status";

export function formatDurationSeconds(duration: number, restoredDuration: number): string {
  const total = duration + restoredDuration;
  const minutes = Math.floor(total / 60);
  const seconds = Math.round(total % 60);
  return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
}

export function computeIsSpeakDisabled(
  status: RecordingStatus,
  releaseRecordingLock: unknown,
  activeNoteIsDeleted: boolean | undefined
): boolean {
  return (
    !!releaseRecordingLock || (status !== RecordingStatus.IDLE && activeNoteIsDeleted !== true)
  );
}

export function computeIsIndicatorVisible(
  isSpeakDisabled: boolean,
  status: RecordingStatus
): boolean {
  return isSpeakDisabled && status !== RecordingStatus.IDLE;
}

export function computeIsNoteRecording(
  status: RecordingStatus,
  activeNoteId: string | null
): boolean {
  return status === RecordingStatus.RECORDING && activeNoteId !== null;
}

export function computeHasFinishedAudioRecording(status: RecordingStatus): boolean {
  return [RecordingStatus.PROCESSING, RecordingStatus.UPLOADING, RecordingStatus.UPLOADED].includes(
    status
  );
}
